import React from 'react'
import { Route, Switch } from 'utils-next/routes'

import { SUBSPACES_LIST_PATH } from './SubspaceManager.routes'
import { SubspaceListView } from './scenes'

export function SubspacesManager() {
  return (
    <Switch>
      <Route path={SUBSPACES_LIST_PATH} component={SubspaceListView} exact />
    </Switch>
  )
}
